export function addPageAction(name, attributes) {
  window.newrelic?.addPageAction(name, attributes);
}
